<template>
	<div class="newsletter-management-container">
		<Hint
			:label="`${$t('controlPanel.landingPage.newsletterLabel')}`"
			:hint="`${$t('controlPanel.landingPage.newsletterTip')}`"
		/>
		<draggable v-model="newsletters" group="people" @start="drag=true" @end="drag=false" class="draggable-container">
			<div v-for="newsletter in newsletters" :key="newsletter.order" class="newsletter-wrapper">
				<NewsletterTemplate :newsletter="newsletter"/>
				<div class="newsletter-buttons">
					<IconTooltip
						imageName="edit-green.svg"
						:hoverText="`${$t('controlPanel.landingPage.buttons.edit')}`"
						iconWidth="30px"
						:iconClick="(event) => editNewsletter(event, newsletter)"
					/>
					<IconTooltip
						imageName="delete.svg"
						:hoverText="`${$t('controlPanel.landingPage.buttons.delete')}`"
						iconWidth="25px"
						:iconClick="(event) => deleteNewsletter(event, newsletter)"
					/>
				</div>
			</div>
		</draggable>
		<div class="management-newsletter-buttons">
			<button class="management-button" @click="saveOrder">{{
					$t('controlPanel.landingPage.buttons.saveOrder')
				}}
			</button>
			<IconTooltip
				imageName="plus-in-circle.svg"
				:hoverText="`${$t('controlPanel.landingPage.buttons.create')}`"
				iconWidth="38px"
				:iconClick="createNewsletter"
			/>
		</div>
		<NewsletterForm ref="newsletterModal" :newsletterChange="newsletterChange"/>
	</div>
</template>

<script>
import Hint from "@/common/components/Hint";
import draggable from 'vuedraggable';
import * as GRAPHQL_SERVICE from "@/drc/services/drc-graphql-service";
import IconTooltip from "@/drc/components/buttons/IconTooltip";
import NewsletterForm from "@/drc/pages/controlPanel/landingPage/NewsletterForm";
import NewsletterTemplate from "@/drc/pages/controlPanel/landingPage/NewsletterTemplate"
import * as NewsletterService from "@/drc/services/newsletter.form.service"
import {NOTIFICATION_TYPE, PLATFORMS} from "@/common/utils/constants";

export default {
	name: "NewsletterManagement",
	components: {
		Hint,
		draggable,
		IconTooltip,
		NewsletterForm,
		NewsletterTemplate
	},
	data() {
		return {
			newsletters: [],
			displayHint: false
		}
	},
	mounted() {
		this.fetchAllNewsletters();
	},
	methods: {
		saveOrder() {
			this.newsletters.forEach((newsletter, index) => {
				newsletter.displayOrder = index + 1;
			});

			GRAPHQL_SERVICE.updateNewsletters([...this.newsletters])
				.then(() => {
					this.showNotification(`${this.$t('notifications.successUpdatedNotificationOrder')}`, NOTIFICATION_TYPE.SUCCESS)
				})
				.catch((error) => {
					this.showNotification(`${this.$t('notifications.error')}`, NOTIFICATION_TYPE.ERROR)
					console.error(error);
				})
		},
		newsletterChange(newsletter) {
			if (!this.newsletters.includes(newsletter)) {
				this.newsletters.push(newsletter)
			}
		},
		createNewsletter() {
			let newsletter = {...NewsletterService.newsletter};
			newsletter.platform = PLATFORMS.DRC
			newsletter.displayOrder = this.newsletters.length;

			this.$refs.newsletterModal.openNewsletterModal(newsletter);
		},
		editNewsletter(event, newsletter) {
			if (event) {
				event.preventDefault()
			}
			GRAPHQL_SERVICE.updateNewsletters([newsletter])
				.then(() => {
					this.$refs.newsletterModal.openNewsletterModal(newsletter);
				})
				.catch((error) => console.error(error))
		},
		deleteNewsletter(event, newsletterInput) {
			if (event) {
				event.preventDefault()
			}
			GRAPHQL_SERVICE.deleteNewsLetter(newsletterInput)
				.then(() => {
					let index = this.newsletters.indexOf(newsletterInput);
					this.newsletters.splice(index, 1);
				})
				.catch((error) => console.error(error))
		},
		fetchAllNewsletters() {
			GRAPHQL_SERVICE.fetchNewsLetters()
				.then((response) => {
					this.newsletters = response;
				})
				.catch((error) => console.error(error))
		},
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.newsletter-management-container {
	.draggable-container {
		padding: 3% 2%;
		background: #0D2A3D;
		min-width: 100%;
		display: flex;
		flex-direction: column;
		gap: 1vh;
		margin-top: 5px;
		margin-bottom: 35px;

		@media (max-width: $mobile) {
			gap: 2.5vh;
		}

		.newsletter-wrapper {
			min-height: 8vh;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-between;
			backdrop-filter: blur(1vh);
			padding: 0.2vw;
			cursor: pointer;
			align-items: center;

			.newsletter-buttons {
				min-height: 8vh;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				position: relative;
				flex-basis: 3%;

				@media (max-width: $tablet) {
					flex-basis: 6%;
				}

				@media (max-width: $mobile) {
					flex-basis: 100%;
					flex-direction: row;
					flex-wrap: wrap;
					gap: 15px;
					min-height: 5vh;
				}
			}
		}
	}

	.management-newsletter-buttons {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		gap: 20px;

		.management-button {
			cursor: pointer;
			background-color: #00E7FF;
			padding: 10px 15px;
			border-radius: 4px;
			border: 1px solid #00E7FF;
			text-transform: uppercase;
			width: fit-content;
		}
	}

}
</style>
